// Public CMS fetching helper for Fodtid

const CMS_BASE = "https://api.dev.auxo.dk/public";

export async function fetchCmsList(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE}/content/${collectionName}`);
    if (!res.ok) {
      console.warn(`CMS fetch failed for ${collectionName}: ${res.status}`);
      return [];
    }
    const data = await res.json();
    return Array.isArray(data) ? data : (data.items || []);
  } catch (err) {
    console.error(`CMS fetch error for ${collectionName}:`, err);
    return [];
  }
}

export async function fetchCmsItemBySlug(slug, lang = 'da') {
  try {
    const res = await fetch(`${CMS_BASE}/by-slug/${lang}/${slug}`);
    if (!res.ok) {
      const fallbackRes = await fetch(`${CMS_BASE}/by-slug/${slug}`);
      if (fallbackRes.ok) return await fallbackRes.json();
      return null;
    }
    return await res.json();
  } catch (err) {
    console.error(`CMS slug fetch error for ${slug}:`, err);
    return null;
  }
}

export async function fetchCmsItemById(collectionName, entryId) {
  try {
    const res = await fetch(`${CMS_BASE}/content/${collectionName}/${entryId}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(`CMS ID fetch error for ${entryId}:`, err);
    return null;
  }
}

// Fallback / initial static data if network is offline during dev
export const DEFAULT_SITE_SETTINGS = {
  company_name: "Fodtid ApS",
  phone: "82 82 10 10",
  email: "kontakt@fodtid.dk",
  hours: "Mandag - Lørdag: 9:00 - 18:00",
  coverage_area: "Hele Sjælland – minus øerne",
  cvr: "44137992",
  address: "Perikumhaven 63A, 2730 Herlev"
};
